import { createJsonbObjectEditor } from "../_resources/jsonbObjectEditor.js";

export default function ({ dom, message }) {

  const render = (pageId, base_url, hasPageEditAccess) => {

    const editor = createJsonbObjectEditor({
      dom,
      message,
      heading: "Theme colors and pixels",
      table: 'pages',
      recordId: pageId,
      fieldName: 'theme_variables', 
      base_url,
      schema: {
        "color-primary": {type: "color", label: "Primary color", value: "#2b2b5b"},
        "color-logotext": {type: "color", label: "Logo text color", value: "#2b2b5b"},
        "color-menutext": {type: "color", label: "Menu text color", value: "#222222"},
        "color-chartswitchertext": {type: "color", label: "Chart switcher text color", value: "#2b2b5b"},
        "color-black": {type: "color", label: "Black color", value: "#222222"},
        "color-grey": {type: "color", label: "Grey color", value: "#ccc"},
        "color-grey-medium": {type: "color", label: "Grey medium color", value: "#b2b2b2"},
        "color-grey-light": {type: "color", label: "Grey light color", value: "#ECEBE9"},
        "color-blue-dark": {type: "color", label: "Blue dark color", value: "#607889"},
        "color-blue-darker": {type: "color", label: "Blue darker color", value: "#425663"},
        "color-footer-link": {type: "color", label: "Footer link color", value: "#607889"},
        "color-footer-text": {type: "color", label: "Footer text color", value: "#666"},
        "color-button-hover": {type: "color", label: "Button hover color", value: "#fff"},
        "color-button-inset": {type: "color", label: "Button inset color", value: "#2b2b5b44"},
        "color-button-border": {type: "color", label: "Button border color", value: "#2b2b5b"},
        "color-button-background": {type: "color", label: "Button background color", value: "#c7c7ff22"},
        "color-barely-visible": {type: "color", label: "Barely visible color", value: "#f5f9fb"},
        "color-background": {type: "color", label: "Background color", value: "#fff"},
        "body-min-width": {type: "text", label: "Body minimum width", value: "250px"},
        "header-height-small": {type: "text", label: "Header height in small profile", value: "32px", comment: "example: 32px"},
        "header-height-large": {type: "text", label: "Header height in large profile", value: "32px", comment: "example: 32px"},
        "header-height-xlarge": {type: "text", label: "Header height in xlarge profile", value: "50px", comment: "example: 50px"}
      },
      allowEdit: hasPageEditAccess
    });

    editor.load();
  };

  return { render };
}

